import { Component, Input } from '@angular/core';

@Component({
  selector: 'ui-fh-svg-refunds',
  templateUrl: './fh-svg-refunds.component.html',
  styleUrl: './fh-svg-refunds.component.scss'
})
export class FhSvgRefundsComponent {
  @Input() color: string = '';
}
